import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungMoenchengladbach() {
  return (
    <CityPageTemplate
      city="Mönchengladbach"
      slug="moenchengladbach"
      intro="Mönchengladbach am Niederrhein – digitale, unabhängige Finanzberatung ohne Umwege."
      description="Unabhängige & digitale Finanzberatung für Mönchengladbach: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
